
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(200|27|412)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
